import { render, staticRenderFns } from "./PathoMemberDashboard.vue?vue&type=template&id=1ac41f76"
import script from "./PathoMemberDashboard.vue?vue&type=script&lang=js"
export * from "./PathoMemberDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports